import moment from 'moment';

export default {
    defaultConfig: {
        defaultInputFormat: 'YYYY-MM-DD HH:mm:ss',
        defaultOutputFormat: 'D MMM YYYY HH:mm',
        locale: 'en-gb',
        localeConfig: {week: {dow: 1}},
    },
    
    install(Vue, {locale, localeConfig}) {
        switch (locale) {
            case 'de': require('moment/locale/de'); break;
            case 'en-gb': require('moment/locale/en-gb'); break;
        }

        moment.updateLocale(locale, localeConfig);
        Vue.filter('date', require('../filters/dateFilter').default);
        Vue.$moment = Vue.prototype.$moment = moment;
    },
};